<template>
  <div class="container-fluid" id="choice">
    <div class="row wrapper">
      <div class="col-12 col-md-4 side-banner">
        <div class="header">
          <h2 class="mt-2 mb-1">&nbsp;</h2>
          <div class="hero-image" alt="Your insurance needs"></div>
        </div>
      </div>
      <div class="col-12 col-md-8 main-banner">
        <div class="main">
          <h1 tabindex="0">Estimate your ideal level of cover</h1>

          <p>This calculator helps provide an estimate of what you may currently need for death cover, total and permanent disablement (TPD) and income protection. </p>

          <div class="row d-flex justify-content-between">
            <b-card
              title="I'd like to see how much cover I need"
              class="col-lg-12 col-xl-6 text-center"
            >
              <b-card-text>
                This calculator can give you an idea of the approximate cover level of insurance based on your personal and/or family needs. The calculation below is an estimate and hould be used as a guide only.
              </b-card-text>
              <router-link tag="button" class="next-button" to="/about" tabindex="0" role="button">Find the right cover level</router-link>
            </b-card>

            <b-card
              title="I'd like to see how much cover will cost"
              class="col-lg-12 col-xl-6 text-center"
            >
              <b-card-text>
                This calculator can give you an idea of the approximate cost of insurance based on which {{ pageContent.companyName }} product you hold, and how you joined us. The calculation below is an  estimate—it’s not a quote and should be used as a guide only.
              </b-card-text>
              <router-link tag="button" class="next-button" to="/next-options" tabindex="0" role="button">I know what I need</router-link>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomFooter from '../components/CustomFooter';

export default {
  name: 'Choice',
  components: {CustomFooter},
  computed: {
		...mapGetters(["pageContent"]),
  },
  mounted() {
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  }
};
</script>
